import { Component, OnInit } from '@angular/core';

import { emptyInvoicingService, IInvoicingService } from "../../../model/invoicing-service";
import { PersonService } from "../../../services/person.service";
import { TranslateService } from "@ngx-translate/core";
import { MyInvoicingServicesService } from "../../../services/my-invoicing-services.service";
import { LoginService } from "../../../services/login.service";
import { emptyPerson, IPerson } from "../../../model/person";
import { ToastsManager } from "ng2-toastr";
import { IHttpErrorsResponse } from "../../../model/http-errors-response";

@Component({
  selector: 'app-inv-invoicing-service-list',
  templateUrl: './inv-invoicing-service-list.component.html',
  styleUrls: ['./inv-invoicing-service-list.component.css']
})
export class InvInvoicingServiceListComponent implements OnInit {

  /**
   * My InvoicingServices
   *
   * @type {IInvoicingService[]}
   */
  myInvoicingServices: IInvoicingService[] = [];

  /**
   * My InvoicingService
   *
   * @type {IInvoicingService}
   */
  myInvoicingService: IInvoicingService = emptyInvoicingService;

  /**
   * My InvoicingService
   *
   * @type {IInvoicingService}
   */
  person: IPerson = emptyPerson;

  /**
   *
   * @type {IHttpErrorsResponse}
   */
  errors: IHttpErrorsResponse;

  constructor(
    private myInvoicingServicesService: MyInvoicingServicesService,
    private loginService: LoginService,
    private personService: PersonService,
    private translate: TranslateService,
    private toastr: ToastsManager,
  ) { }

  ngOnInit() {
    this.person = this.loginService.getPerson();
    this.myInvoicingServicesService.myInvoicingServices$
      .subscribe(myInvoicingServices => {
        this.myInvoicingServices = myInvoicingServices;
      });

    this.myInvoicingServicesService.myInvoicingService$
      .subscribe(myInvoicingService => {
        this.myInvoicingService = myInvoicingService;
      });
  }

  /**
   * Set my default company
   *
   * @param defaultInvoicingService
   */
  setPreference(defaultInvoicingService) {
    this.personService.setPreference(this.person, defaultInvoicingService)
      .subscribe(
        result => {
          this.translate.get("inv.preferences.title").subscribe((res: string) => {
            this.toastr.info(res).then();
          });
          this.myInvoicingServicesService.updateDefault(defaultInvoicingService);
          this.setPersonAuthenticated(result);
        },
        error => {
          this.errors = error;
        });
  }

  /**
   *
   * @param result
   */
  setPersonAuthenticated(result) {
    this.person = result;
    localStorage.removeItem('person');
    localStorage.setItem('person', JSON.stringify(this.person));
  }

  markAsChecked(esfAuthorized) {
    return (this.person.preferences !== undefined)
      ? (esfAuthorized.identifier == this.person.preferences['invoicingService'])
      : false;
  }
}



// WEBPACK FOOTER //
// ./src/app/app-manager/invoicing-services/inv-invoicing-service-list/inv-invoicing-service-list.component.ts